import { defineMessages } from 'react-intl';

export const scope = 'app.components.DashboardNav';

// Static nav labels. Sport-terminology labels (drills/sessions/athletes) are rendered
// from the company term lookup, not from here — see dashboard-nav.component.tsx.
export const messages = defineMessages({
  settings: { id: `${scope}.settings`, defaultMessage: 'Settings' },
  dashboard: { id: `${scope}.dashboard`, defaultMessage: 'Dashboard' },
  users: { id: `${scope}.users`, defaultMessage: 'Users' },
  format: { id: `${scope}.format`, defaultMessage: 'Format' },
  evaluate: { id: `${scope}.evaluate`, defaultMessage: 'Evaluate' },
  checkIn: { id: `${scope}.checkIn`, defaultMessage: 'Check-in' },
  assignments: { id: `${scope}.assignments`, defaultMessage: 'Assignments' },
  communication: { id: `${scope}.communication`, defaultMessage: 'Communication' },
  admin: { id: `${scope}.admin`, defaultMessage: 'Admin' },
  signOut: { id: `${scope}.signOut`, defaultMessage: 'Sign Out' },
  unsavedTitle: {
    id: `${scope}.unsavedTitle`,
    defaultMessage: 'You have unsaved changes. Are you sure you want to leave?',
  },
  unsavedNo: { id: `${scope}.unsavedNo`, defaultMessage: 'No' },
  unsavedYes: { id: `${scope}.unsavedYes`, defaultMessage: 'Yes' },
});
